export default (initial) => ({
    itemId: initial.id,
    quantity: initial.quantity,
    loading: false,

    change(delta) {
        if (this.loading) return;

        const newQty = this.quantity + delta;
        if (newQty < 1) return;

        this.loading = true;

        fetch(Alpine.store('app').routes.cart.changeQuantity, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': Alpine.store('app').csrf,
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                item_id: this.itemId,
                quantity: newQty,
            }),
        })
            .then(r => r.json())
            .then(data => {
                this.quantity = newQty;
                Alpine.store('cart').sync(data.cart);
            })
            .finally(() => {
                this.loading = false;
            });
    },

    remove() {
        if (this.loading) return;

        this.loading = true;

        fetch(Alpine.store('app').routes.cart.removeItem, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': Alpine.store('app').csrf,
                'Accept': 'application/json',
            },
            body: JSON.stringify({
                item_id: this.itemId,
            }),
        })
            .then(r => r.json())
            .then(data => {
                Alpine.store('cart').sync(data.cart);
                this.$refs.row.remove();
            })
            .finally(() => {
                this.loading = false;
            });
    },
});
